/**
 * Page chrome for the parent Resources page (`/circle`).
 *
 * The header is a real `PageHead` (#2109 R3-B23): the eyebrow is the nav
 * row's own key (`NAV_KEY.support`), so it reads the same as the sidebar in
 * every language, and the page gets the route-aware `document.title` and
 * focus-to-H1 behaviour every other page has. The H1 is "Resources".
 *
 * Wave w1023c (Victor, 2026-10-23) deleted the People address book, and with
 * it the header's contact count, Export and Add contact actions (#2437,
 * #2501). The nav row's label is set in `parent-nav.ts`, not here.
 */
import { useTranslation } from 'react-i18next';
import { PageHead } from '@/components/editorial';
import { NAV_KEY } from '@/i18n/keys/nav';

export function CircleHeader() {
  const { t } = useTranslation('circle');
  return (
    <header className="pb-4 border-b border-border/60">
      <PageHead eyebrowKey={NAV_KEY.support} title={t('header.title')} />
    </header>
  );
}
